<template>
	<el-dialog top="30vh" class="alert-dialog" :visible="visible" center width="30%">
	  <div class="dia-content">
	    <div v-html="title"></div>
	  </div>
	  <span slot="footer" class="dialog-footer">
	    <el-button class="cancel" round @click="cancel">{{cancelContent}}</el-button>
	    <el-button class="commit" round type="primary" @click="commit">{{commitContent}}</el-button>
	  </span>
	</el-dialog>
</template>

<script>
	export default {
		props:{
			title:{
				type: String,
				default: ""
			},
			commitContent:{
				type: String,
				default: "确 定"
			},
			cancelContent:{
				type: String,
				default: "取 消"
			}
		},
		data(){
			return {
				visible : false,
				data: null
			}
		},
		methods:{
			open(data={}){
				this.visible = true;
				this.data = data;
				console.log("data: ",data);
			},
			close(){
				this.visible = false;
			},
			cancel(){
				this.$emit("cancel");
				this.close();
			},
			commit(){
				this.$emit("commit",this.data);
				setTimeout(()=>{
					this.close();
				},500)
			}
		}
	}
</script>

<style  scoped lang="stylus">
	
	.alert-dialog {
	  /deep/{
			.el-dialog__header {
			  display: none;
			}
		}
	  .dia-content {
	    padding: 0.2rem 0.2rem;
	    padding-top: 0.3rem;
	    color: #333333;
	    font-size: 0.18rem;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	  }
	  .cancel,
	  .cancel:hover {
	    border-color: #02a8a2;
	    color: #02a8a2;
	    padding: 0.1rem 0.45rem;
	  }
	  .commit,
	  .commit:hover {
	    background-color: #02a8a2;
	    color: #ffffff;
	    border-color: #02a8a2;
	    padding: 0.1rem 0.45rem;
	  }
	}
</style>